<template>
<m-pageframe
    title="Admin: Uptime"
>
<v-container>

    <h2
        style="margin-bottom: 15px"
    >
        Dev
    </h2>

    <div
        style="margin-left: 25px"
    >
        <p>
            <b>DB Uptime Check</b><br/>
            <a href="http://127.0.0.1:8080/api/v1/public/uptime/check-uptime-db" target="_blank">http://127.0.0.1:8080/api/v1/public/uptime/check-uptime-db</a><br/>
        </p>

        <p>
            <b>DB Uptime Text</b><br/>
            dave-my-mind-is-going-i-can-feel-it
        </p>

        <p>
            <b>Rest API Uptime Check</b><br/>
            <a href="http://127.0.0.1:8080/api/v1/public/uptime/check-uptime-rest-api" target="_blank">http://127.0.0.1:8080/api/v1/public/uptime/check-uptime-rest-api</a><br/>
        </p>

        <p>
            <b>Rest API Uptime Text</b><br/>
            and-now-for-something-completely-different
        </p>

        <p>
            <b>Scheduler Uptime Check</b><br/>
            <a href="http://127.0.0.1:8080/api/v1/public/uptime/check-uptime-scheduler" target="_blank">http://127.0.0.1:8080/api/v1/public/uptime/check-uptime-scheduler</a><br/>
        </p>

        <p>
            <b>Scheduler Uptime Text</b><br/>
            tick-tock-you-do-not-stop
        </p>

        <p>
            <b>Front End Uptime Check</b><br/>
            <a href="http://127.0.0.1:8081/app/home" target="_blank">http://127.0.0.1:8081/app/home</a><br/>
        </p>

        <p>
            <b>Front End Uptime Text (it is in a meta tag)</b><br/>
            i-have-a-lovely-bunch-of-coconuts
        </p>
    </div>

    
    <h2
        style="margin-bottom: 15px"
    >
        Staging
    </h2>
    <div
        style="margin-left: 25px"
    >
        <p>
            <b>DB Uptime Check</b><br/>
            <a href="https://www.staging-redchirp.com/api/v1/public/uptime/check-uptime-db" target="_blank">https://www.staging-redchirp.com/api/v1/public/uptime/check-uptime-db</a><br/>
        </p>

        <p>
            <b>DB Uptime Text</b><br/>
            dave-my-mind-is-going-i-can-feel-it
        </p>

        <p>
            <b>Rest API Uptime Check</b><br/>
            <a href="https://www.staging-redchirp.com/api/v1/public/uptime/check-uptime-rest-api" target="_blank">https://www.staging-redchirp.com/api/v1/public/uptime/check-uptime-rest-api</a><br/>
        </p>

        <p>
            <b>Rest API Uptime Text</b><br/>
            and-now-for-something-completely-different
        </p>

        <p>
            <b>Scheduler Uptime Check</b><br/>
            <a href="https://www.staging-redchirp.com/api/v1/public/uptime/check-uptime-scheduler" target="_blank">https://www.staging-redchirp.com/api/v1/public/uptime/check-uptime-scheduler</a><br/>
        </p>

        <p>
            <b>Scheduler Uptime Text</b><br/>
            tick-tock-you-do-not-stop
        </p>

        <p>
            <b>Front End Uptime Check</b><br/>
            <a href="https://www.staging-redchirp.com/app/home" target="_blank">https://www.staging-redchirp.com/app/home</a><br/>
        </p>

        <p>
            <b>Front End Uptime Text (it is in a meta tag)</b><br/>
            i-have-a-lovely-bunch-of-coconuts
        </p>
    </div>

    <h2
        style="margin-bottom: 15px"
    >
        Production
    </h2>
    <div
        style="margin-left: 25px"
    >
        <p>
            <b>DB Uptime Check</b><br/>
            <a href="https://app.redchirp.com/api/v1/public/uptime/check-uptime-db" target="_blank">https://app.redchirp.com/api/v1/public/uptime/check-uptime-db</a><br/>
        </p>

        <p>
            <b>DB Uptime Text</b><br/>
            dave-my-mind-is-going-i-can-feel-it
        </p>

        <p>
            <b>Rest API Uptime Check</b><br/>
            <a href="https://app.redchirp.com/api/v1/public/uptime/check-uptime-rest-api" target="_blank">https://app.redchirp.com/api/v1/public/uptime/check-uptime-rest-api</a><br/>
        </p>

        <p>
            <b>Rest API Uptime Text</b><br/>
            and-now-for-something-completely-different
        </p>

        <p>
            <b>Scheduler Uptime Check</b><br/>
            <a href="https://app.redchirp.com/api/v1/public/uptime/check-uptime-scheduler" target="_blank">https://app.redchirp.com/api/v1/public/uptime/check-uptime-scheduler</a><br/>
        </p>

        <p>
            <b>Scheduler Uptime Text</b><br/>
            tick-tock-you-do-not-stop
        </p>

        <p>
            <b>Front End Uptime Check</b><br/>
            <a href="https://app.redchirp.com/app/home" target="_blank">https://app.redchirp.com/app/home</a><br/>
        </p>

        <p>
            <b>Front End Uptime Text (it is in a meta tag)</b><br/>
            i-have-a-lovely-bunch-of-coconuts
        </p>
    </div>

    <h2
        style="margin-bottom: 15px"
    >
        Simulate Downtime
    </h2>
    <div
        style="margin-left: 25px"
    >
        These controls will allow you to simulate downtime <em>in the current environment.</em>

        <v-switch
            label="Database"
            :value="is_db_up"
            readonly
        />

        <v-btn
            v-if="is_db_up"
            v-on:click="onClickSimulateDown('db', true)"
        >
            Simulate DB Offline
        </v-btn>

        <v-btn
            v-if="!is_db_up"
            v-on:click="onClickSimulateDown('db', false)"
        >
            End Simulate DB Offline
        </v-btn>

        <v-switch
            label="Rest API"
            :value="is_rest_api_up"
            readonly
        />

        <v-btn
            v-if="is_rest_api_up"
            v-on:click="onClickSimulateDown('rest-api', true)"
        >
            Simulate Rest API Offline
        </v-btn>

        <v-btn
            v-if="!is_rest_api_up"
            v-on:click="onClickSimulateDown('rest-api', false)"
        >
            End Simulate Rest API Offline
        </v-btn>


        <v-switch
            label="Task Scheduler"
            :value="is_scheduler_up"
            readonly
        />

        <v-btn
            v-if="is_scheduler_up"
            v-on:click="onClickSimulateDown('scheduler', true)"
        >
            Simulate Scheduler Offline
        </v-btn>

        <v-btn
            v-if="!is_scheduler_up"
            v-on:click="onClickSimulateDown('scheduler', false)"
        >
            End Simulate Scheduler API Offline
        </v-btn>



    </div>

    <h2
        style="margin-bottom: 15px; margin-top: 15px"
    >
        Instance Control
    </h2>
    <div
        v-if="uptime != null"
        style="position: relative"
    >
        <div
            style="position: absolute; top: 0px; right: 0px"
        >
            <v-icon
                v-on:click="getUptime()"
            >
                mdi-reload
            </v-icon>
        </div>
        Instance Name: <b>{{uptime.instance_name}}</b><br/>
        Start Time: <b>{{$rc.pretty(uptime.start_time, 'date_and_time')}}</b><br/><br/>

        Restart the RedChirp service (do this only if you really know what you are doing)<br/><br/>

        <v-btn
            v-on:click="onClickRestartRedChirp"
            :disabled="!$rc.$state.hasRedChirpStaffRoleAdministrator()"
        >
            Restart RedChirp
        </v-btn>
    </div>


</v-container>
</m-pageframe>
</template>

<script>
export default {

    data() {
        return {
            is_rest_api_up: false,
            is_db_up: false, 
            is_scheduler_up: false,
            uptime: null,
        }
    },

    mounted () {
        this.update();
        this.getUptime();
    },

    methods: {
        
        getUptime()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'GET: /api/v1/uptime',
            
                'params' : {
                    },
            
                'on_success': (data) => {
                        this.uptime = data;
                    },
            
                'on_error': 'Unable to get uptime information',
            });
        },

        update() {
             
            this.$rc.checkUptime(
                'db',
            
                (data) => {
                    this.is_db_up = true;
                },
            
                () => {
                    this.is_db_up = false;
                },
            );

            this.$rc.checkUptime(
                'rest-api',
            
                (data) => {
                    this.is_rest_api_up = true;
                },
            
                () => {
                    this.is_rest_api_up = false;
                },
            );

            this.$rc.checkUptime(
                'scheduler',
            
                (data) => {
                    this.is_scheduler_up = true;
                },
            
                () => {
                    this.is_scheduler_up = false;
                },
            );

        },

        onClickSimulateDown(service, down)
        {
            this.$rc.showSpinner();
            
            this.$rc.simulateDowntime(
                service,
                down,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.update();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to simulate downtime/uptime.');
                },
            );
        },

        onClickRestartRedChirp()
        {
            this.$rc.confirm({
                'title': 'Restart RedChirp',
                'body': 'Are you certain that you would like to reboot RedChirp (only do this if you know what you are doing) (this only works in staging and production)',
                'btn_text_ok': 'Yes',
                'btn_text_cancel': 'No',
                'on_ok': () => {
                    this.doRestart();
                },
            });  
        },

        doRestart()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/uptime/reboot',
            
                'params' : {
                    },
            
                'on_success': (data) => {
                        this.$rc.alert('Reboot started', 'RedChirp has begun restarting.<br/><br/>Watch for a change of the instance name from '+this.uptime.instance_name+', to something different to know the reboot is complete');
                    },
            
                'on_error': () => {
                    this.$rc.alert('Reboot started', 'RedChirp has begun restarting.<br/><br/>Watch for a change of the instance name from '+this.uptime.instance_name+', to something different to know the reboot is complete');
                }
            });
        },

        

        
    },
}
</script>

<style lang="scss" scoped>
</style>